<div class="flex min-h-screen flex-col">
  <app-banner />
  <main class="flex-1 p-4">
    <router-outlet />
  </main>
  <app-footer />
</div>
